export const MOCK_SECTIONS = [
  { key: 'dashboard', label: 'Painel' },
  { key: 'automation', label: 'Automação' },
  { key: 'infrastructure', label: 'Infraestrutura' },
  { key: 'integrations', label: 'Integrações' },
  { key: 'storage', label: 'Armazenamento' },
  { key: 'administration', label: 'Administração' },
  { key: 'processes', label: 'Processos' },
];

export const MOCK_PROFILES = {
  ADM_WES: 'adm_wes',
  ADM_CLIENTE: 'adm_cliente',
  USER_CLIENTE: 'user_cliente',
};

export const MOCK_PROFILE_LABELS = {
  [MOCK_PROFILES.ADM_WES]: 'ADM WES',
  [MOCK_PROFILES.ADM_CLIENTE]: 'ADM Cliente',
  [MOCK_PROFILES.USER_CLIENTE]: 'User cliente',
};

